<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="title" id="_idParaDest-1">Past Imperative</h1>
<h2 class="subtitle">Round One of the Great Game</h2>
<p class="author">Dave Duncan</p>
<p class="colophon _idGenParaOverride-1"><img alt="" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PastImperative.vue?1cf54118